import { CalendarDaysIcon, TruckIcon } from "lucide-react";
import { useFormatter, useTranslations } from "next-intl";

import { Button } from "@/shared-web.ui/ui.button";
import { Text } from "@/shared-web.ui/ui.text";
import { cn } from "@/shared-web.ui/util.cn";

import { ServerDataOutput } from "../data.subscription-data";
import { getDaysUntil } from "./util.days-until";

interface NextShipBannerProps {
  className?: string;
  data: ServerDataOutput;
  now?: number;
  onClick?: () => void;
}
const NextShipBanner = (props: NextShipBannerProps) => {
  const { className, data, now, onClick } = props;

  const { subscriptionData: {
    subscriptionMeta: {
      schedule: { nextShippingDate: nextShippingDateString },
    },
  } } = data;

  const nextShippingDate = new Date(`${nextShippingDateString}T00:00:00+07:00`);
  const formatter = useFormatter();

  const nextShippingDateFormatted = formatter.dateTime(nextShippingDate, {
    weekday: "short",
    day: "numeric",
    month: "long",
    timeZone: "Asia/Bangkok",
  });

  const daysUntil = getDaysUntil(nextShippingDate, now);

  const t = useTranslations("stf_m_subscription.screen_subscription");

  return (
    <div className={cn(
      `
        bg-info-1 border border-info-6 rounded-3 flex
        flex-col items-center gap-1 p-3
      `,
      className,
    )}
    >
      <div className="flex w-full max-w-xs flex-col gap-2">
        <div className={`
          flex flex-row items-center justify-between
        `}
        >
          <div className="flex flex-row items-center gap-1.5">
            <TruckIcon
              strokeWidth="1.5"
              className="text-info-11 size-4 -scale-x-100"
            />
            <Text semanticColor="info" size="2">
              {t("next_shipping")}
            </Text>
          </div>
          <Text semanticColor="info" size="2">
            {t("next_shipping_in_days", { days: daysUntil })}
          </Text>
        </div>

        <div className={`
          flex flex-row items-baseline justify-between
        `}
        >
          <Text semanticColor="info" size="6" weight="medium">
            {nextShippingDateFormatted}
          </Text>
          <Button
            variant="solid"
            semanticColor="info"
            size={{ initial: "1", sm: "2" }}
            onClick={onClick}
          >
            <CalendarDaysIcon
              strokeWidth="1.5"
              className="size-3.5"
            />
            {t("shipment_schedule_button")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export { NextShipBanner };
